import React from 'react';

function Project() {
  return (
      <section className="tc-project-style1 header">
        <div className="main-info">
          <div className="container">
            <div className="tags mb-50">
              <a href="#"> Mimari </a>
              <a href="#"> Peyzaj </a>
            </div>
            <h1 className="title"> Villa Moda </h1>
            <div className="text color-666 mt-30">
              Gaziantep Aktoprak’ın kalbinde, doğayla iç içe modern villalar. <br />
              Konfor, mahremiyet ve lüks bir arada.
            </div>
          </div>
        </div>

        <div className="main-img">
          <img
              src="/innerpages/assets/img/projects/aktoprak/270623_66%20-%20Foto_69%20-%20Foto-min.jpg"
              alt="Aktoprak Villaları Ana Görsel"
              className="img-cover"
              data-speed="1.25"
          />
        </div>

        <div className="description">
          <div className="container">
            <h3 className="sub-title fsz-45 mb-60 wow fadeInUp slow" data-wow-delay="0.2s">
              Proje Açıklaması
            </h3>
            <div className="text fsz-24 mb-20 fw-500 wow fadeInUp slow" data-wow-delay="0.2s">
              Aktoprak’ın sakin atmosferinde konumlanan bu seçkin villa projesi, doğayla uyumlu bir yaşam sunarken aynı zamanda teknolojik imkanlardan ödün vermez. Her detay, estetik ve işlevsellik gözetilerek tasarlandı.
            </div>
            <div className="text fsz-24 fw-500 wow fadeInUp slow" data-wow-delay="0.2s">
              Geniş bahçeler, özel otopark alanları ve akıllı ev sistemleriyle donatılan her villa, Gaziantep’te modern ve ferah bir yaşamın yeni standardını belirliyor.
            </div>
          </div>

          <div className="services">
            <div className="container">
              <div className="row">
                <div className="col-lg-7">
                  <div className="items">
                    <div className="row">
                      <div className="col-lg-6">
                        {/*<div className="item mt-100 wow fadeInUp slow" data-wow-delay="0.2s">
                          <small className="d-block color-666 text-uppercase fsz-12 mb-30">
                            Hizmetler
                          </small>
                          <div className="links fsz-18 fw-500">
                            Mimari Tasarım, <br /> İç Mekan Tasarımı, Peyzaj <br /> Planlaması
                          </div>
                        </div>*/}
                      </div>
                      <div className="col-lg-6">
                        <div className="item mt-100 wow fadeInUp slow" data-wow-delay="0.4s">
                          <small className="d-block color-666 text-uppercase fsz-12 mb-30">
                            Lokasyon
                          </small>
                          <div className="links fsz-18 fw-500">
                            Aktoprak, Gaziantep <br /> Türkiye
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="item mt-100 wow fadeInUp slow" data-wow-delay="0.2s">
                          <small className="d-block color-666 text-uppercase fsz-12 mb-30">
                            İnşaat Alanı
                          </small>
                          <div className="links fsz-18 fw-500">
                            2550m2
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="item mt-100 wow fadeInUp slow" data-wow-delay="0.4s">
                          <small className="d-block color-666 text-uppercase fsz-12 mb-30">
                            Durum
                          </small>
                          <div className="links fsz-18 fw-500">
                            Tamamlandı <br /> 24 Şubat 2024
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img src="/innerpages/assets/img/projects/aktoprak/ak4-min.jpg" alt="" className="line wow" />
          </div>

          <div className="imgs mt-120">
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <div className="img th-600 radius-7 overflow-hidden mt-30 wow zoomIn slow" data-wow-delay="0.2s">
                    <img src="/innerpages/assets/img/projects/aktoprak/ak8-min.jpg" alt="Salon Görseli" className="img-cover" />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="img th-600 radius-7 overflow-hidden mt-30 wow zoomIn slow" data-wow-delay="0.4s">
                    <img src="/innerpages/assets/img/projects/aktoprak/31.08.2023%20HAVUZ-min.jpg" alt="Bahçe Görseli" className="img-cover" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

       {/* <div className="challenge pb-120">
          <div className="container">
            <h3 className="sub-title fsz-45 mb-60 wow fadeInUp slow" data-wow-delay="0.2s">
              Zorluklar
            </h3>
            <div className="text fsz-24 mb-20 fw-500 wow fadeInUp slow" data-wow-delay="0.2s">
              Aktoprak’ın gelişmekte olan yapısı içinde, hem mahremiyeti koruyan hem de doğayla iç içe olmayı sağlayan
              modern ve sürdürülebilir bir yaşam alanı tasarlamak hedefimizdi.
            </div>

            <ul className="dots-list fsz-18 color-666 wow fadeInUp slow" data-wow-delay="0.2s">
              <li className="d-flex my-4">
                <span className="icon me-3"> • </span> Yüksek yalıtım ve enerji verimliliği standartlarını sağlamak
              </li>
              <li className="d-flex my-4">
                <span className="icon me-3"> • </span> Ulaşım kolaylığını bozmadan sessizliği korumak
              </li>
              <li className="d-flex my-4">
                <span className="icon me-3"> • </span> Farklı aile yapıları için modüler villa planları sunmak
              </li>
            </ul>

            <div className="imgs mt-120">
              <div className="row">
                <div className="col-lg-4">
                  <div className="img th-350 radius-7 overflow-hidden mt-30 wow zoomIn slow" data-wow-delay="0.2s">
                    <img src="/innerpages/assets/img/projects/aktoprak/ak8-min.jpg" alt="İnşaat Aşaması"
                         className="img-cover"/>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="img th-350 radius-7 overflow-hidden mt-30 wow zoomIn slow" data-wow-delay="0.4s">
                    <img src="/innerpages/assets/img/projects/aktoprak/270623_67%20-%20Foto_69%20-%20Foto-min.jpg"
                         alt="İç Mekan" className="img-cover"/>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="img th-350 radius-7 overflow-hidden mt-30 wow zoomIn slow" data-wow-delay="0.6s">
                    <img src="/innerpages/assets/img/projects/aktoprak/31.08.2023%20HAVUZ-min.jpg" alt="Yeşil Alanlar"
                         className="img-cover"/>
                  </div>
                </div>
              </div>
            </div>

            <h3 className="sub-title fsz-45 mb-60 mt-150 wow fadeInUp slow" data-wow-delay="0.2s">
              Çözüm
            </h3>
            <div className="text fsz-24 mb-20 fw-500 wow fadeInUp slow" data-wow-delay="0.2s">
              Geniş doğal manzara açılarının sağlandığı ve esnek yaşam alanlarının sunulduğu bir yerleşim planı
              geliştirdik. Villalar, güneş enerjisine hazır çatılar, su geri dönüşüm sistemleri ve doğal havalandırma
              çözümleriyle geleceğe hazır hale getirildi.
            </div>
          </div>
        </div>*/}

        <div className="main-slider-img wow fadeInUp slow w-75 mx-auto" data-wow-delay="0.2s">
          <div className="swiper-wrapper">
            {[1, 4, 5, 17, 22].map((n) => (
                <div className="swiper-slide" key={n}>
                  <div className="img">
                    <img
                        src={`/innerpages/assets/img/projects/aktoprak/ak${n}-min.jpg`}
                        alt={`Aktoprak Villaları Görsel ${n}`}
                        className="img-cover"
                    />
                  </div>
                </div>
            ))}
          </div>
          <div className="arrows">
            <div className="swiper-button-prev"></div>
            <div className="swiper-pagination"></div>
            <div className="swiper-button-next"></div>
          </div>
        </div>
      </section>
  );
}

export default Project;